import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { config } from "../config/siteConfig";
import { scrollToTarget } from "../lib/scroll";
import { openLeadForm } from "../lib/leadForm";

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    scrollToTarget(href);
  };

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled
          ? "bg-[#08162B] lg:bg-[#08162B]/90 lg:backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-[72px] flex items-center justify-between">
        <a
          href="#hero"
          onClick={(e) => go(e, "#hero")}
          data-testid="nav-logo"
          className="font-display text-white text-xl sm:text-2xl tracking-[0.08em] leading-none"
        >
          THE ECOM BIBLE
        </a>
        <nav className="hidden lg:flex items-center gap-9">
          {config.nav.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => go(e, item.href)}
              data-testid={`nav-link-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="font-mono text-[11px] uppercase tracking-[0.22em] text-white/60 hover:text-white transition-colors duration-300"
            >
              {item.label}
            </a>
          ))}
        </nav>
        <button
          onClick={() => openLeadForm("nav")}
          data-testid="nav-cta-button"
          className="bg-white text-[#08162B] font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.2em] px-4 sm:px-6 py-2.5 sm:py-3 hover:bg-[#D4AF37] hover:text-[#08162B] transition-colors duration-300"
        >
          GET THE BOOK
        </button>
      </div>
    </header>
  );
};

export const StickyMobileCta = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.85);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="sticky-mobile-cta"
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-[#08162B] border-t border-white/10 px-4 py-3 flex items-center justify-between gap-3"
        >
          <div className="min-w-0">
            <p className="font-display text-white text-lg tracking-[0.08em] truncate">THE ECOM BIBLE</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/50">
              {config.book.price || "Instant digital access"}
            </p>
          </div>
          <button
            onClick={() => openLeadForm("sticky-mobile")}
            data-testid="sticky-mobile-cta-button"
            className="shrink-0 bg-white text-[#08162B] font-mono text-[11px] uppercase tracking-[0.18em] px-5 py-3.5"
          >
            GET THE BOOK
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Nav;
